import React from "react";
import {List, Modal, Table, Tooltip} from "antd";
import {HotSheetList} from "../../../../models/hotsheet";
import {Config} from "../../../../controller/Global";
import {WorkOrderList} from "../../../../models/workorder";
import {pagination} from "../../../../controller/Utils";

const MANIFEST = Config.constant.service_type.manifest;
const moment = require('moment');

export class ShowHotSheet extends React.Component {
  state = {
    data: [],
    workorder: [],
    pagination: pagination,
    params: {}
  };
  fetch = (ids) => {
    HotSheetList({ids: ids, depth: 4})
      .then(response => {
        this.setState({data: response.data.results})
      });
    this.fetchWorkOrder({'hotsheet_id': ids[0]})
  };

  fetchWorkOrder = (params = {}) => {
    params =  {...this.state.params, ...params};
    this.setState({params});
    WorkOrderList(params)
      .then(response => {
        const pagination = { ...this.state.pagination };
        pagination.total = response.data.count;
        this.setState({workorder: response.data.results, pagination})
      })
  }

  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetchWorkOrder({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      ...filters,
    });
  };

  componentDidUpdate(prevProps) {
    const {data, visible} = this.props;
    if (data && visible && visible !== prevProps.visible && data !== prevProps.data)
      this.fetch(data)
  }


  render() {
    const {data, workorder, pagination} = this.state;
    const {visible} = this.props;
    const work_order_columns = [
      {
        title: 'Work Order Number',
        dataIndex: 'work_order_number',
        key: 'work_order_number',
      }, {
        title: 'Service Date',
        dataIndex: 'service.0.service_date',
        key: 'service__service_date',
      }, {
        title: 'Type',
        dataIndex: 'service.0.type',
        render: type => type.toUpperCase()
      }, {
        title: 'Number',
        dataIndex: 'service.0.manifest_number',
      }, {
        title: 'Quantity',
        dataIndex: 'service.0.waste_data.0.quantity',
      }
    ];

    return (
      <Modal title="View Details" centered visible={visible} onOk={() => this.props.setModelVisible()} onCancel={() => this.props.setModelVisible()} width='75%' className="view-data-modal view-hotsheet-mdl">
        {data.map((item, index) => {
          return (
            <div key={index} className="row single-data-row">
              <div className="col-12 header-view-data">
                <div className="view-data-div">
                  <span>Hot Sheet Number</span>
                </div>
                <div className="view-data-div">
                  <span>Generator <i className="fa fa-info-circle" /></span>
                </div>
                <div className="view-data-div">
                  <span>Bill To <i className="fa fa-info-circle" /></span>
                </div>
                <div className="view-data-div">
                  <span>Date</span>
                </div>
                <div className="view-data-div">
                  <span>PO <i className="fa fa-info-circle" /></span>
                </div>
              </div>
              <div className="view-data-row">
                <div className="col-12 quote-details">
                  <div className="view-data-div">
                    <span>{item.hot_sheet_number}</span>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={`${item.generator.address} ${item.generator.city} ${item.generator.zip_code}`}>
                      <span>{item.generator.company_name} {item.generator.account_number} </span>
                    </Tooltip>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={`${item.bill_to.company_name} ${item.bill_to.account_number}`}>
                      <span>{item.bill_to.company_name} {item.bill_to.account_number} </span>
                    </Tooltip>
                  </div>
                  <div className="view-data-div">
                    <span>{item.date}</span>
                  </div>
                  <div className="view-data-div">
                    <Tooltip placement="bottom" title={item.po}>
                      <span>{item.po}</span>
                    </Tooltip>
                  </div>
                </div>
              </div>
                <div className="col-12 view-data-service">
                  <h6>Services</h6>
                  <div className="col-12  padding-0">
                    <List className="demo-loadmore-list view-data-list dynamic-area" itemLayout="horizontal" dataSource={data} renderItem={item => (
                      <List.Item>
                        <List.Item.Meta
                          description={
                            <div className="added-services">
                              <div className="row added-services-header">
                                <span>{item.service.type === MANIFEST?'Manifest Number': 'BOL Number' }</span>
                                <span>Service name</span>
                                <span>Service Date</span>
                                <span>Crew members</span>
                                <span>Transporter</span>
                                <span>Facility</span>
                                <span>Truck Type</span>
                              </div>
                              <div key={index}>
                                <div className="row">
                                  <span>{item.service.manifest_number}</span>
                                  <span>{item.service.service_type.name}</span>
                                  <span>{item.service.service_date}</span>
                                  <span>{item.service.number_people}</span>
                                  <span>{item.service.transporter.name}</span>
                                  <span>{item.service.facility.name}</span>
                                  <span>{item.service.truck_type.map(truck => truck.type_name).join(', ')}</span>
                                </div>
                                <div className="row job-desc-view">
                                    <div className="col-12">
                                      <h4>Job Description:</h4>
                                       <Tooltip placement="top" title={item.service.job_description}>
                                          <p>{item.service.job_description?item.service.job_description.substring(0,100): '-'}</p>
                                       </Tooltip>
                                    </div>
                                  </div>
                                <div className="row added-services-header multiple-desc">
                                  <span className="quantity-serv">Code</span>
                                  <span className="description-serv">Description</span>
                                  <span className="quantity-serv">Quantity</span>
                                  <span className="quantity-serv">Unit</span>
                                  <span className="quantity-serv">Price</span>
                                  <React.Fragment>
                                    <span className="quantity-serv">Tank Size</span>
                                    <span className="quantity-serv">Cycle</span>
                                  </React.Fragment>
                                </div>
                                  {item.service.waste_data.map((stream, index) => {
                                    return   <div className="row multiple-desc" key={index}>
                                      <span className="quantity-serv">{stream.waste_stream ? stream.waste_stream.code : ''}</span>
                                      <Tooltip placement="bottom" title={stream.waste_stream ? stream.waste_stream.description : ''}>
                                        <span className="description-serv info"> {stream.waste_stream ? stream.waste_stream.description : ''}</span>
                                      </Tooltip>
                                      <span className="quantity-serv">{stream.quantity}</span>
                                      <span className="quantity-serv">{stream.waste_stream ? stream.waste_stream.unit : ''}</span>
                                      <span className="quantity-serv">{stream.price}</span>
                                      <span className="quantity-serv text-center">{stream.tank_size}</span>
                                      <span className="quantity-serv text-center">{stream.cycle}</span>
                                    </div>
                                  })}
                              </div>
                            </div>} />
                      </List.Item>
                    )} />
                  </div>
                  <div className="col-12">
                    <Table columns={work_order_columns}  locale={{ emptyText: 'No Work Order Available' }} onChange={this.handleTableChange} pagination={pagination} rowKey={row => row.id} dataSource={workorder} />
                  </div>
                </div>
            </div>
          )
        })}
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/tracks/hotsheet/popups/ShowHotSheet.jsx